// Fixed set of access domains. Mirrors the backend enum; used both as a
// fallback when GET /domains is unavailable and to validate the
// :domain route param on the Domain Details page.
export const DOMAINS = [
  'B2B',
  'B2C',
  'CLIENT',
  'ADMIN',
  'MERCHANT',
  'AGENT',
  'DASHBOARD',
];

export const isValidDomain = (domain) =>
  !!domain && DOMAINS.includes(String(domain).toUpperCase());

// ── Mini FilterBuilder field set ──────────────────────────────────────────────
// Reduced column set for the "who has this domain" view. Reuses the shared
// FilterBuilder component (src/components/FilterBuilder.js) — these configs
// serialise to the same Sequelize-style ?where= the users list already emits.
//
// Note on booleans: FilterBuilder renders enum options as label === value, so
// there is no label/value split. user_status (tinyint active flag) and
// is_blocked (bool) are therefore modelled as `boolean` fields (True/False),
// which coerce to true/false and compare correctly against 1/0 / bool columns.
export const MINI_USER_FIELDS = [
  { key: 'name', label: 'Name', type: 'string' },
  { key: 'email', label: 'Email', type: 'string' },
  { key: 'phone', label: 'Phone', type: 'string' },
  { key: 'user_status', label: 'Active (account status)', type: 'boolean' },
  { key: 'is_blocked', label: 'Blocked', type: 'boolean' },
  { key: 'compliance', label: 'Compliance', type: 'number' },
  { key: 'created_at', label: 'Created', type: 'date' },
];
